import { createPortal } from "react-dom";
import styles from "./styles.module.scss";

interface Props {
  children: React.ReactNode;
  isVisible: boolean;
  anchorRect: DOMRect | null;
}

export function MenuAtom({ children, isVisible, anchorRect }: Readonly<Props>) {
  if (!isVisible || !anchorRect) return null;

  return createPortal(
    <div
      className={styles.menu}
      style={{
        top: anchorRect.bottom,
        left: anchorRect.left - 115,
      }}
    >
      {children}
    </div>,
    document.body
  );
}
